import { InputAdornment, TextField } from "@mui/material";
import { FieldProps } from "@rjsf/core";
import { IconPremium } from "./IconPremium";

export const TextFieldPremium = (props: FieldProps) => {

    const { title: label } = props.schema
    const { disabled } = (props.uiSchema['ui:options'] || {}) as Record<string, any>

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        props.onChange(e.currentTarget.value)
    }

    return (
        <TextField
            disabled={disabled !== false}
            id={props.idSchema.$id}
            label={label}
            InputProps={{
                endAdornment: (
                    disabled &&
                    <InputAdornment position="end">
                        <IconPremium />
                    </InputAdornment>
                ),
            }}
            onChange={handleChange}
        />
    )
}
